import * as API from "../API/index";
import { authorizedUser } from "components/Common/commonFunctions";

export const getCountryList = async () => {
  try {
    const res = await API.country_list();
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
